import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import * as fileSaver from 'file-saver';
import { tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { NotyService } from './noty.service';
import { noDefaultErrorHandler } from './interceptors';

@Injectable({
  providedIn: 'root',
})
export class DownloadUtilService {
  constructor(private http: HttpClient, private notyService: NotyService) {}

  download(url: string, fileName: string, authorizationToken?: string) {
    // Note: We're telling the back-end to skip adding the authentication token for all of these calls. Long term
    // this cannot stay this way because when we remove cookies the APIs will fail because they have no
    // authentication of any kind. (BUG-2044)

    let headers = new HttpHeaders({
      'Skip-Auth': 'true',
    });
    if (authorizationToken) {
      headers = headers.set('Authorization', `Bearer ${authorizationToken}`);
    }

    return this.http
      .get(url, {
        headers: headers,
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(
        noDefaultErrorHandler(),
        catchError((err) => {
          this.notyService.error(
            'There was an error downloading the file. Please try again later',
          );
          return throwError(err);
        }),
        tap((response) => {
          const blob = new Blob([response.body || 'There was an Error'], {
            type: 'text/json; charset=utf-8',
          });
          fileSaver.saveAs(blob, response.headers.get('content') || fileName);
        }),
      );
  }

  downloadUsingUrl(url: string, fileName: string, authorizationToken?: string) {
    let headers = new HttpHeaders({
      'Skip-Auth': 'true',
    });
    if (authorizationToken) {
      headers = headers.set('Authorization', `Bearer ${authorizationToken}`);
    }
    return this.http
      .get(url, {
        headers: headers,
        responseType: 'text',
      })
      .pipe(
        noDefaultErrorHandler(),
        catchError((err) => {
          this.notyService.error(
            'There was an error downloading the file. Please try again later',
          );
          return throwError(err);
        }),
        tap((url) => {
          const anchorTag = document.createElement('a');
          anchorTag.href = url;
          anchorTag.download = fileName;
          // start download
          anchorTag.click();
        }),
      );
  }
}
